import React from "react";

import { SlidersHorizontal } from "lucide-react";
import { useTranslation } from "react-i18next";
import { NavLink } from "react-router-dom";

import { APP_TOOLTIP_ID } from "@/src/constants/tooltip";

import type { JSX } from "react";

interface AdvancedRightsLinkProps {
  to: string;
}

export default function AdvancedRightsLink({
  to,
}: AdvancedRightsLinkProps): JSX.Element {
  const { t } = useTranslation("editor-content");

  return (
    <NavLink
      aria-label={t("advancedRightsMode")}
      className="text-muted-foreground hover:text-foreground inline-flex items-center align-middle"
      data-tooltip-content={t("advancedRightsMode")}
      data-tooltip-id={APP_TOOLTIP_ID}
      onClick={(event) => event.stopPropagation()}
      to={to}
    >
      <SlidersHorizontal className="size-5" />
    </NavLink>
  );
}
